(function ($) {
  'use strict';


  /**
   * Main functionality should be in an 'init' function
   */
  var initStickyCta = function () {
    var $self = $(this);
    var desktop = window.matchMedia('(min-width: 768px)');

    ScrollTrigger.config({
      syncInterval: 10,
      autoRefreshEvents: 'visibilitychange,DOMContentLoaded,load,resize'
    });

    function stickCta() {
      if (desktop.matches) {
        var scroll = ScrollTrigger.create({
          id: "trigger1",
          trigger: $('footer').get(0),
          start: 'top bottom',
          pin: false,
          toggleClass: { targets: $self[0], className: 'is-pinned' },
          anticipatePin: 1,
          pinSpacing: false,
          invalidateOnRefresh: true
        });

        ScrollTrigger.observe({
          target: window,
          type: 'scroll',
          onDown: function () {
            var pos = ScrollTrigger.positionInViewport($self.get(0), 'center');
            if (pos < 1) {
              scroll.refresh();
            }
          }
        });
      }
      else {
        var triggers = ScrollTrigger.getAll();
        triggers.forEach( trigger => {
          trigger.kill();
        });
      }
    }

    stickCta();

    $(window).on('resize', function () {
      stickCta();
    });
  };

  /**
   * This is boilerplate: add a behavior to window.DP.behaviors
   */
  window.DP.behaviors.stickyCta = {
    attach: function (context) {
      $(context).find('.cc--sticky-cta').once('stickyCta').each(function () {
        initStickyCta.apply(this);
      });
    }
  };

}(jQuery));
